import { PaperFrameStyled } from '@/components/common/paperFrameStyled';
import { UserContext } from '@/contexts/userContext';
import { IClient } from '@/interfaces/clients';
import ClientList from '@/modules/document/clientList';
import NotesGrid from '@/modules/document/grids/notes/NotesGrid';
import { getClients } from '@/services/advisor';
import { Box, Stack, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

interface NotesProps {
  noteId?: number;
  memo?: string | null;
}

const Notes: React.FC<NotesProps> = ({ noteId, memo }) => {
  const { currentRole } = useContext(UserContext);

  const [clients, setClients] = useState<IClient[]>([]);
  useEffect(() => {
    getClients().then((data) => {
      setClients(data);
    });
  }, []);
  const [selectedClient, setSelectedClient] = useState<IClient | undefined>();

  return (
    <PaperFrameStyled
      sx={{
        paddingX: 3,
        paddingTop: 3,
        paddingBottom: 5,
        gap: 8,
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        overflow: 'hidden',
      }}
    >
      {currentRole === 'advisor' && (
        <ClientList
          items={clients}
          selected={selectedClient}
          onSelect={(client) => setSelectedClient(client)}
        />
      )}

      <Stack
        flex={1}
        gap={4}
        mt={1}
      >
        <Header />

        {memo ? (
          <Box p={2}>
            <Typography whiteSpace='pre-line'>{memo}</Typography>
          </Box>
        ) : (
          <NotesGrid noteId={noteId ?? -1} />
        )}
      </Stack>
    </PaperFrameStyled>
  );
};

const Header = () => {
  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
    >
      <Typography
        variant='h5'
        sx={{
          fontSize: '24px',
          fontWeight: 600,
          lineHeight: '133.4%',
        }}
      >
        Notes
      </Typography>
    </Stack>
  );
};

export default Notes;
